// import React, { useState } from "react";

// const AddPatient = () => {
//   const [form, setForm] = useState({ name: "", age: "", gender: "", contact: "", address: "" });

//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert("Patient added successfully!");
//     setForm({ name: "", age: "", gender: "", contact: "", address: "" });
//   };

//   return (
//     <div className="bg-white shadow text-center rounded w-100 mt-5 ms-3 px-3 py-2">
//       <h4>Add New Patient</h4>
//       <form onSubmit={handleSubmit} className="row g-3">
//         <div className="col-md-6"><input type="text" className="form-control" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required /></div>
//         <div className="col-md-6"><input type="number" className="form-control" name="age" placeholder="Age" value={form.age} onChange={handleChange} required /></div>
//         <div className="col-md-6">
//           <select className="form-control" name="gender" value={form.gender} onChange={handleChange} required>
//             <option value="">Select Gender</option>
//             <option value="Male">Male</option>
//             <option value="Female">Female</option>
//           </select>
//         </div>
//         <div className="col-md-6"><input type="text" className="form-control" name="contact" placeholder="Contact" value={form.contact} onChange={handleChange} required /></div>
//         <div className="col-12"><input type="text" className="form-control" name="address" placeholder="Address" value={form.address} onChange={handleChange} required /></div>
//         <div className="col-12"><button type="submit" className="btn btn-primary border-0 rounded font-bold">Add Patient</button></div>
//       </form>
//     </div>
//   );
// };

// export default AddPatient;



// import React, { useState } from "react";
// import axios from "axios";
// import { API_PATH } from "../Constant/constants";

// const AddPatient = () => {
//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     dateOfBirth: "",
//     gender: "",
//     contactType: "",
//     contactValue: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prevForm) => ({
//       ...prevForm,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authorization token not found. Please log in.");
//       return;
//     }

//    const registrationDate = new Date();

// const pad = (n) => String(n).padStart(2, "0");

// const localDateTime = 
//   `${registrationDate.getFullYear()}-${pad(registrationDate.getMonth() + 1)}-${pad(registrationDate.getDate())} ` + // Space instead of T
//   `${pad(registrationDate.getHours())}:${pad(registrationDate.getMinutes())}:${pad(registrationDate.getSeconds())}`; 

//     const payload = {
    
//       firstName: form.firstName,
//       lastName: form.lastName,
//       dateOfBirth: form.dateOfBirth,
//       gender: form.gender,
//       contacts: [
//         {
     
//           type: form.contactType,
//           value: form.contactValue,
//         },
//       ],
//     registrationDate: localDateTime
//     };

//     try {
//       const response = await axios.post(`${API_PATH}/patients`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (response.status === 201 || response.status === 200) {
//         alert("Patient added successfully!");
//         setForm({
//           firstName: "",
//           lastName: "",
//           dateOfBirth: "",
//           gender: "",
//           contactType: "",
//           contactValue: "",
//         });
//       } else {
//         alert("Unexpected response. Please try again.");
//         console.warn("Unexpected response:", response);
//       }
//     } catch (error) {
//       if (error.response) {
//         console.error("Server responded with error:", error.response);

//         switch (error.response.status) {
//           case 403:
//             alert("Access denied (403). You might not have permission.");
//             break;
//           case 404:
//             alert("API endpoint not found (404). Please check the API path.");
//             break;
//           case 500:
//             alert("Internal server error (500). Please try again later.");
//             break;
//           default:
//             alert(`Error: ${error.response.statusText}`);
//             break;
//         }
//       } else if (error.request) {
//         console.error("No response from server:", error.request);
//         alert("No response from server. Please check your connection.");
//       } else {
//         console.error("Error setting up the request:", error.message);
//         alert("Error setting up the request. Please try again.");
//       }
//     }
//   };

//   return (
//     <div className="bg-white shadow text-center rounded w-100 mt-5 ms-3 px-3 py-2">
//       <h4>className="mb-4">Add New Patient</h4>
//       <form onSubmit={handleSubmit} className="row g-3">
//         <div className="col-md-6">
//           <input
//             type="text"
//             className="form-control"
//             name="firstName"
//             placeholder="First Name"
//             value={form.firstName}
//             onChange={handleChange}
//             required
//           />
//         </div>
//         <div className="col-md-6">
//           <input
//             type="text"
//             className="form-control"
//             name="lastName"
//             placeholder="Last Name"
//             value={form.lastName}
//             onChange={handleChange}
//             required
//           />
//         </div>
//         <div className="col-md-6">
//           <input
//             type="date"
//             className="form-control"
//             name="dateOfBirth"
//             value={form.dateOfBirth}
//             onChange={handleChange}
//             required
//           />
//         </div>
//         <div className="col-md-6">
//           <select
//             className="form-control"
//             name="gender"
//             value={form.gender}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Select Gender</option>
//             <option value="Male">Male</option>
//             <option value="Female">Female</option>
//             <option value="Other">Other</option>
//           </select>
//         </div>
//         <div className="col-md-6">
//           <select
//             className="form-control"
//             name="contactType"
//             value={form.contactType}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Contact Type</option>
//             <option value="Phone">Phone</option>
//             <option value="Email">Email</option>
//             <option value="Other">Other</option>
//           </select>
//         </div>
//         <div className="col-md-6">
//           <input
//             type="text"
//             className="form-control"
//             name="contactValue"
//             placeholder="Contact Info"
//             value={form.contactValue}
//             onChange={handleChange}
//             required
//           />
//         </div>
//         <div className="col-12">
//           <button type="submit" className="btn btn-primary w-100">
//             Add Patient
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AddPatient;




import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_PATH } from "../Constant/constants";
import {Link} from 'react-router-dom'

const AddPatient = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    contactType: "",
    contactValue: "",
  });




  const [filter, setFilter] = useState(""); // Add filter state

  const [patients, setPatients] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const fetchPatients = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(`${API_PATH}/patients`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPatients(response.data);
    } catch (error) {
      console.error("Error fetching patients:", error);
      alert("Failed to fetch patients. Please try again.");
    }
  };

  const handleDelete = async (patientId) => {
    try {
      const token = localStorage.getItem("authToken");
      await axios.delete(`${API_PATH}/patients/${patientId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      alert("Patient deleted successfully!");
      fetchPatients(); // Refresh the patient list
    } catch (error) {
      console.error("Error deleting patient:", error);
      alert("Failed to delete patient. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authorization token not found. Please log in.");
      return;
    }

    const registrationDate = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const localDateTime = `${registrationDate.getFullYear()}-${pad(
      registrationDate.getMonth() + 1
    )}-${pad(registrationDate.getDate())} ${pad(
      registrationDate.getHours()
    )}:${pad(registrationDate.getMinutes())}:${pad(
      registrationDate.getSeconds()
    )}`;

    const payload = {
      firstName: form.firstName,
      lastName: form.lastName,
      dateOfBirth: form.dateOfBirth,
      gender: form.gender,
      contacts: [
        {
          type: form.contactType,
          value: form.contactValue,
        },
      ],
      registrationDate: localDateTime,
    };

    try {
      const response = await axios.post(`${API_PATH}/patients`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201 || response.status === 200) {
        alert("Patient added successfully!");
        setForm({
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          gender: "",
          contactType: "",
          contactValue: "",
        });
        fetchPatients(); // Refresh the patient list
      } else {
        alert("Unexpected response. Please try again.");
        console.warn("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error adding patient:", error);
      alert("Failed to add patient. Please try again.");
    }
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  return (
    <>
    <div className="bg-white shadow text-center rounded w-100 mw-100 mt-5  px-3 py-2">
      <h4 className="mb-4">Add New Patient</h4>
      <form onSubmit={handleSubmit} className="row g-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            name="firstName"
            placeholder="First Name"
            value={form.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            name="lastName"
            placeholder="Last Name"
            value={form.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-4">
          <input
            type="date"
            className="form-control"
            name="dateOfBirth"
            value={form.dateOfBirth}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-4">
          <select
            className="form-control"
            name="gender"
            value={form.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="col-md-4">
          <select
            className="form-control"
            name="contactType"
            value={form.contactType}
            onChange={handleChange}
            required
          >
            <option value="">Contact Type</option>
            <option value="Phone">Phone</option>
            <option value="Email">Email</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            name="contactValue"
            placeholder="Contact Info"
            value={form.contactValue}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-12">
          <button type="submit" className="btn btn-color w-30">
            Add Patient
          </button>
        </div>
      </form>
 </div>
    <div className="bg-white shadow text-center rounded w-100 mt-5  px-3 py-2">
      <h4 className="mt-5">Patient List</h4>
       <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Filter by name or contact"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>
      <table className=" table-bordered table-striped">
        <thead className=" tableborder">
          <tr>
            <th>Sr no.</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Date of Birth</th>
            <th>Gender</th>
            <th>Contact</th>
            <th>Registration Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {patients
            .filter((patient) => {
              const search = filter.toLowerCase();
              return (
                patient.firstName.toLowerCase().includes(search) ||
                patient.lastName.toLowerCase().includes(search) ||
                patient.contacts.some(
                  (contact) =>
                    contact.value && contact.value.toLowerCase().includes(search)
                  
                )
              );
            })
            .map((patient,index) => (
              <tr key={patient.id} className="datahover">
                <td>{index + 1}</td>
                <td>{patient.firstName}</td>
                <td>{patient.lastName}</td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.gender}</td>
                <td>
                  {patient.contacts.map((contact, index) => (
                    <div key={index}>
                      {contact.type}: {contact.value}
                    </div>
                  ))}
                </td>
                <td>{patient.registrationDate}</td>
                <td>
              <button className="btn btn-danger" onClick={() => handleDelete(patient.id)}>Delete</button>
              <Link to={`/receptionist/home/appointments/prescription/${patient.id}`} className="btn btn-sm btn-primary ms-2">
                Add Prescription
              </Link>
              <Link to={`/receptionist/home/prescription/preview/${patient.id}`} className="btn btn-sm btn-info ms-2">
                Preview
              </Link>
              <Link to={`/receptionist/home/prescription/print/${patient.id}`} target="_blank" className="btn btn-sm btn-success ms-2">
                Print
              </Link>
            </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
    </>
   
   
  );
};

export default AddPatient;


